import { render } from "./mobileExamination.vue?vue&type=template&id=537434da&scoped=true"
import script from "./mobileExamination.vue?vue&type=script&lang=js"
export * from "./mobileExamination.vue?vue&type=script&lang=js"

import "./mobileExamination.vue?vue&type=style&index=0&id=537434da&lang=less&scoped=true"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537434da"]])

export default __exports__